import React from 'react'
import Link from 'next/link'
import { ArrowRight } from 'lucide-react'
import type { Event } from '@/payload-types'
import { EventCard } from '../Events/EventCard'

interface ResourcesEventsProps {
  events: Event[]
}

const MAX_EVENTS = 3

export function ResourcesEvents({ events }: ResourcesEventsProps) {
  if (!events || events.length === 0) {
    return null
  }

  const displayedEvents = events.slice(0, MAX_EVENTS)

  return (
    <section className="py-8 md:py-12 px-6 md:px-12 lg:px-16">
      <div className="max-w-380 mx-auto">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <h2 className="text-2xl md:text-3xl font-medium text-gray-900">Events</h2>
          <Link
            href="/events"
            className="flex items-center gap-1.5 text-brand-gold hover:text-brand-gold-light text-sm font-medium transition-colors"
          >
            <span>See all events</span>
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        {/* The same card as /events, so the two pages can't drift apart. */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {displayedEvents.map((event) => (
            <EventCard key={event.id} event={event} />
          ))}
        </div>
      </div>
    </section>
  )
}
